import { render, staticRenderFns } from "./image-selector.vue?vue&type=template&id=169c2348&"
import script from "./image-selector.vue?vue&type=script&lang=js&"
export * from "./image-selector.vue?vue&type=script&lang=js&"
import style0 from "./image-selector.vue?vue&type=style&index=0&id=169c2348&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports